import { createSelector, Selector } from 'reselect';
import { ReduxState } from '../state';
import {
  OptimizelyState,
  OptimizelyFeaturesList,
  OptimizelyFeature,
} from './state';

const OptimizelySelector = (state: ReduxState): OptimizelyState =>
  state.Optimizely;

export const selectOptimizelyEnabledFeatures = createSelector(
  OptimizelySelector,
  (optimizely): OptimizelyFeaturesList => optimizely.enabledFeatures || []
);

export const makeSelectOptimizelyEnabledFeature = (
  feature: OptimizelyFeature
): Selector<ReduxState, boolean> =>
  createSelector(selectOptimizelyEnabledFeatures, (enabledFeatures): boolean =>
    enabledFeatures.includes(feature)
  );
